import { createFileRoute } from "@tanstack/react-router";
import { PrintersPage } from "../features/printers/printers-page";
import { Require } from "../features/require";

/** More > Printers (MG-06, P5-T24, P5-T25). */
export const Route = createFileRoute("/more/printers/")({ component: Page });

function Page() {
	return (
		<Require permission="printers.manage">
			<PrintersPage />
		</Require>
	);
}
